import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'
import type Geometry from 'ol/geom/Geometry'
import type Feature from 'ol/Feature'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { setLayerMetadata } from '../../layerMetadata'

import { findOrderMarker } from './findOrderMarker'
import { createOrderFeature } from './createOrderFeature'

const nonblockingRender = createNonBlockingRenderByTime()

export const changelogAddOrderFeatures = async (
  layer: VectorLayer<VectorSource>,
  markers: Record<string, uui.domain.ui.map.markers.Order>,
  mapStyles: uui.domain.ui.map.markers.MapStyles['order'],
  selection: Set<string>,
  selectedOrderIds: Set<string>,
  markerIds: IterableIterator<string>,
) => {
  const features: Feature<Geometry>[] = []

  nonblockingRender.reset()

  for (const markerId of markerIds) {
    await nonblockingRender.next()

    const marker = findOrderMarker(markers, markerId)
    if (!marker) continue

    const selected = selection.has(markerId)

    features.push(createOrderFeature(marker, mapStyles, selectedOrderIds, selected))
  }

  // add all new features to the layer
  layer.getSource()?.addFeatures(features)

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
